import { createContext, useContext, useEffect, useState } from "react";
import api, { apiError } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=unauth
  const [menus, setMenus] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [menusLoaded, setMenusLoaded] = useState(false);

  const loadMenus = () =>
    api.get("/my-menus")
      .then((r) => { setMenus(r.data.menus); setIsAdmin(r.data.is_admin); })
      .catch(() => {})
      .finally(() => setMenusLoaded(true));

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setUser(null);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => { setUser(r.data); loadMenus(); })
      .catch(() => {
        localStorage.removeItem("token");
        setUser(null);
      });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("token", data.token);
    setUser(data.user);
    await loadMenus();
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("token", data.token);
    setUser(data.user);
    await loadMenus();
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("token");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, menus, isAdmin, menusLoaded, login, register, logout, apiError }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
